import React from 'react';

import { FieldArray, useFormikContext } from 'formik';
import { StyledGoalItemListItem } from 'modules/Report/layout/Goals/GoalItem/styled';

import AddToDoItem from '../AddTodo';
import GoalItem from './GoalItemLabel';
import { StyledGoalFormToDoList } from './styled';

interface PropsType {
	name: string;
	type?: 'error' | 'warning' | 'info' | 'success';
	withLimit?: boolean;
}

function GoalFormToDoList({ name, type = 'info', withLimit = false }: PropsType) {
	const { values } = useFormikContext<any>();
	const goals: any = values[name];

	return (
		<StyledGoalFormToDoList>
			<FieldArray
				name={name}
				render={({ push, remove }) => (
					<>
						{goals?.map((item: any, index: number) => (
							// @ts-ignore
							<StyledGoalItemListItem key={index} type={type}>
								<GoalItem
									label={item.title}
									number={index + 1}
									onRemove={() => remove(index)}
								/>
							</StyledGoalItemListItem>
						))}
						{withLimit ? (
							goals?.length < 6 && (
								<AddToDoItem onSave={(title) => push({ title, is_done: false })} />
							)
						) : (
							<AddToDoItem onSave={(title) => push({ title, is_done: false })} />
						)}
					</>
				)}
			/>
		</StyledGoalFormToDoList>
	);
}

export default GoalFormToDoList;
